import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "phoneLink"
const PhoneLinkIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M8.25 18C8.871 18 9.375 18.504 9.375 19.125S8.871 20.25 8.25 20.25 7.125 19.746 7.125 19.125 7.629 18 8.25 18" />
          <path
            fillRule="evenodd"
            d="M13.5 1.5C14.328 1.5 15 2.172 15 3V7.403C14.638 7.39 14.267 7.463 13.919 7.635Q13.69 7.749 13.5 7.905V3H3V15.75H13.5V15.742Q13.555 15.78 13.614 15.816H13.615C14.049 16.075 14.535 16.167 15 16.117V21C15 21.828 14.328 22.5 13.5 22.5H3L2.847 22.492C2.09 22.415 1.5 21.777 1.5 21V3C1.5 2.172 2.172 1.5 3 1.5zM3 21H13.5V17.25H3z"
            clipRule="evenodd"
          />
          <path d="M18.33 4.72C18.629 4.433 19.104 4.443 19.39 4.742 20.26 5.65 20.947 6.724 21.415 7.904 21.884 9.084 22.125 10.35 22.125 11.625S21.884 14.165 21.415 15.345 20.26 17.602 19.39 18.509C19.103 18.807 18.63 18.817 18.33 18.53 18.03 18.244 18.02 17.77 18.308 17.47 19.04 16.705 19.623 15.796 20.02 14.793S20.626 12.713 20.626 11.625 20.42 9.461 20.021 8.457C19.624 7.454 19.042 6.545 18.309 5.78 18.02 5.481 18.03 5.006 18.33 4.72" />
          <path d="M16.504 6.502C16.84 6.26 17.309 6.338 17.55 6.675 18.573 8.102 19.123 9.837 19.125 11.615 19.127 13.396 18.58 15.13 17.561 16.56 17.32 16.897 16.85 16.976 16.515 16.736 16.177 16.496 16.099 16.027 16.34 15.69 17.174 14.52 17.627 13.09 17.625 11.617Q17.625 11.56 17.622 11.505V11.456C17.587 10.042 17.135 8.675 16.33 7.549 16.09 7.21 16.167 6.743 16.504 6.502" />
          <path d="M15.007 8.906C15.237 8.934 15.447 9.068 15.568 9.281L15.59 9.319Q15.66 9.463 15.723 9.61C16.013 10.303 16.149 11.058 16.12 11.816Q16.11 12.142 16.058 12.461 16.015 12.723 15.946 12.98C15.826 13.43 15.647 13.864 15.409 14.264L15.393 14.289 15.367 14.329 15.325 14.378C15.235 14.478 15.123 14.55 15 14.591 14.8 14.658 14.575 14.642 14.381 14.527 14.025 14.315 13.908 13.855 14.12 13.499L14.122 13.494Q14.234 13.303 14.323 13.098 14.368 12.993 14.407 12.888C14.535 12.532 14.609 12.152 14.623 11.763Q14.63 11.528 14.61 11.298C14.584 10.99 14.52 10.689 14.421 10.403Q14.346 10.187 14.246 9.984C14.062 9.614 14.214 9.164 14.585 8.98 14.72 8.912 14.867 8.89 15.007 8.906M9.75 3.75C10.164 3.75 10.5 4.086 10.5 4.5S10.164 5.25 9.75 5.25H6.75C6.336 5.25 6 4.914 6 4.5S6.336 3.75 6.75 3.75z" />
        </svg>
      }
    </span>
  )
}
export default PhoneLinkIcon
